/**
 * @description: 艺人设置
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="store-set-personnel">
        <!-- 巨嗨佳人艺人身份证是否必填 -->
        <div class="store-jys-set" v-show="show1">
            <div class="jys-list">
                <h1 class="title">艺人资料必填项设置</h1>
                <p class="p-hint">注：1 艺人身份证号默认是必填，如不想必填选择否</p>
                <p class="p-hint">2 艺人等级是否必填，【是】则app端新增艺人资料或审核艺人资料时，必须选择艺人等级</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="jysList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(1)">返回</button>
                </div>
            </div>
        </div>


        <!-- 艺人报备设置 -->
        <div class="store-ywb-set" v-show="show2">
            <div class="ywb-list">
                <h1 class="title">艺人报备设置</h1>
                <p class="p-hint">注：1 艺人微信报备，设置关闭后，巨嗨佳人微信端报备入口隐藏</p>
                <p class="p-hint">2 艺人app端扫码报备设置，设置关闭后，app端艺人报备二维码不显示</p>
                <p class="p-hint">3 艺人app端刷卡报备设置，设置关闭后，app端不支持刷卡报备</p>
                <p class="p-hint">4 二次签到设置：设置开启后，艺人报备签到当天可支持签退后再次签到</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="ywbList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(2)">返回</button>
                </div>
            </div>
        </div>


        <!-- 艺人签到后多久可签退 -->
        <div class="store-yqd-set" v-show="show3">
            <div class="yqd-list">
                <h1 class="title">艺人签到后多久可签退</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="yqdList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(3)">返回</button>
                </div>
            </div>
        </div>


        <!-- 艺人是否支持手动扫码下钟 -->
        <div class="store-ysx-set" v-show="show4">
            <div class="ysx-list">
                <h1 class="title">艺人是否支持手动扫码下钟</h1>
                <p class="p-hint">艺人默认支持扫码下钟，若选否则艺人需发起下钟审批，审批通过、服务停止或关房后才能自动下钟</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="ysxList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(4)">返回</button>
                </div>
            </div>
        </div>


        <!-- 未签到是否支持上钟打卡 -->
        <div class="store-wqdz-set" v-show="show5">
            <div class="wqdz-list">
                <h1 class="title">未签到是否支持上钟打卡</h1>
                <p class="p-hint">否：艺人未报备签到时，在包厢无法扫码上钟</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="wqdzList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(5)">返回</button>
                </div>
            </div>
        </div>

        <!-- 台票购买设置 -->
        <div class="store-tpgm-set" v-show="show6">
            <div class="tpgm-list">
                <h1 class="title">台票购买设置</h1>
                <p class="p-hint">注：1 未签到是否可购买，否：艺人未报备签到时，无法购买台票。</p>
                <p class="p-hint">2 购票未使用是否可购买，否：艺人购买台票后，单个营业日内未上钟使用的，无法重复购票。</p>
                <p class="p-hint">3 上钟状态下是否可购买，否：艺人当前处于上钟状态未下钟的，无法购买台票。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="tpgmList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(6)">返回</button>
                </div>
            </div>
        </div>

        <!-- 艺人上钟模式设置 -->
        <div class="store-tpgm-set" v-show="show7">
            <div class="tpgm-list">
                <h1 class="title">艺人上钟模式设置</h1>
                <p class="p-hint">注：1 台费模式：app端设置有台费规则时，艺人上钟扣取对应台费规则金额</p>
                <p class="p-hint">2 台票模式：艺人上钟时判断是否购买台票，需购买台票后方可正常上钟</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="szmsList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(7)">返回</button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                show1: false,
                show2: false,
                show3: false,
                show4: false,
                show5: false,
                show6: false,
                show7: false,
            }
        },
        watch: {
            
        },
        mounted: function() {
            
        },
        methods: {
            // 显示页面
            showTargetPage(num) {
                this[`show${num}`] = true

                if(num == '1') {
                    this.innitJysTable()
                } else if(num == '2') {
                    this.innitYwbTable()
                } else if(num == '3') {
                    this.innitYqdTable()
                } else if(num == '4') {
                    this.innitYsxTable()
                } else if(num == '5') {
                    this.innitWqdzTable()
                } else if(num == '6') {
                    this.innitTpgmTable()
                } else if(num == '7') {
                    this.innitSzmsTable()
                }
            },
            // 返回
            backIndex(index) {
                this[`show${index}`] = false
                this.$emit('targetBack')
            },


            /*
             * 巨嗨佳人艺人身份证是否必填
             */
            innitJysTable: function() {
                let _this = this;
                $(_this.$refs.jysList).bootstrapTable('destroy');
                $(_this.$refs.jysList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getJysList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "personnel_id_card",
                        title: "艺人身份证是否必填",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.jysSub(row.shop_id, 'personnel_id_card', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "pson_level_required",
                        title: "艺人资料等级是否必填",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.jysSub(row.shop_id, 'pson_level_required', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getJysList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": 'personnel_data_required'
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 设置
            jysSub: function(id, key, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config_type": key,
                            "config": check_stock
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/upConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg("操作成功！");
                            $(_this.$refs.jysList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 巨嗨佳人艺人微信报备设置
             */
            innitYwbTable: function() {
                let _this = this;
                $(_this.$refs.ywbList).bootstrapTable('destroy');
                $(_this.$refs.ywbList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYwbList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "20%"
                    }, {
                        field: "open_wx_sign",
                        title: "艺人微信报备设置",
                        width: "20%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.ywbSub(row.id, check_stock, 'open_wx_sign');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>开启</option><option value='-1'>关闭</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>开启</option><option value='-1' selected>关闭</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "open_app_scan_sign",
                        title: "艺人app端扫码报备设置",
                        width: "20%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.ywbSub(row.id, check_stock, 'open_app_scan_sign');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>开启</option><option value='-1'>关闭</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>开启</option><option value='-1' selected>关闭</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "open_app_card_sign",
                        title: "艺人app端刷卡报备设置",
                        width: "20%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.ywbSub(row.id, check_stock, 'open_app_card_sign');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>开启</option><option value='-1'>关闭</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>开启</option><option value='-1' selected>关闭</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "pson_multiple_sign_in",
                        title: "二次签到设置",
                        width: "20%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.ywbSub(row.id, check_stock, 'pson_multiple_sign_in');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>开启</option><option value='-1'>关闭</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>开启</option><option value='-1' selected>关闭</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getYwbList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getShopConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 设置
            ywbSub: function(id, check_stock, key) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            [key]: check_stock
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/setShopConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.ywbList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 艺人签到后多久可签退
             */
            innitYqdTable: function() {
                let _this = this;
                $(_this.$refs.yqdList).bootstrapTable('destroy');
                $(_this.$refs.yqdList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYqdList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "personnel_sign_out_limit",
                        title: "艺人签到后多久可签退",
                        width: "30%",
                        events: {
                            'blur .input-val': function(e, value, row) {
                                _this.yqdSub(row.id, $.trim($(this).val()));
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<input type="text" class="input-val" value="'+ value +'" />' + '分钟';
                        }
                    }]
                });
            },
            // 列表
            getYqdList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Setting/getShopConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            yqdSub: function(id, input_val) {
                const _this = this;

                Vue.axios.post('Setting/setShopConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "personnel_sign_out_limit": input_val
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.yqdList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },


            /*
             * 艺人是否支持手动扫码下钟
             */
            innitYsxTable: function() {
                let _this = this;
                $(_this.$refs.ysxList).bootstrapTable('destroy');
                $(_this.$refs.ysxList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYsxList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "personnel_scan_clock",
                        title: "艺人是否支持手动扫码下钟",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.ysxSub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getYsxList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Shop/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": 'personnel_scan_clock'
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.count,
                            rows: res.data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            ysxSub: function(id, check_stock) {
                const _this = this;

                Vue.axios.post('Shop/upConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config_type": 'personnel_scan_clock',
                            "config": check_stock
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.ysxList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },


            /*
             * 未签到是否支持上钟打卡
             */
            innitWqdzTable: function() {
                let _this = this;
                $(_this.$refs.wqdzList).bootstrapTable('destroy');
                $(_this.$refs.wqdzList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getWqdzList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "pson_unsign_can_clock_in",
                        title: "未签到是否支持上钟打卡",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.wqdzSub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getWqdzList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Shop/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": 'pson_unsign_can_clock_in'
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.count,
                            rows: res.data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            wqdzSub: function(id, check_stock) {
                const _this = this;

                Vue.axios.post('Shop/upConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config_type": 'pson_unsign_can_clock_in',
                            "config": check_stock
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.wqdzList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },


            /*
             * 台票购买设置
             */
            innitTpgmTable: function() {
                let _this = this;
                $(_this.$refs.tpgmList).bootstrapTable('destroy');
                $(_this.$refs.tpgmList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getTpgmList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "25%"
                    }, {
                        field: "pson_ticket_unsign",
                        title: "未签到是否可购买",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.tpgmSub(row.id, check_stock, 'pson_ticket_unsign');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "pson_ticket_unused",
                        title: "购票未使用是否可购买",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.tpgmSub(row.id, check_stock, 'pson_ticket_unused');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "pson_ticket_onclock",
                        title: "上钟状态下是否可购买",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.tpgmSub(row.id, check_stock, 'pson_ticket_onclock');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    } ]
                });
            },
            // 列表
            getTpgmList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Setting/getShopConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            tpgmSub: function(id, check_stock, key) {
                const _this = this;

                Vue.axios.post('Setting/setShopConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                           [key]: check_stock
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.tpgmList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },


            /*
             * 艺人上钟模式设置
             */
            innitSzmsTable: function() {
                let _this = this;
                $(_this.$refs.szmsList).bootstrapTable('destroy');
                $(_this.$refs.szmsList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getSzmsList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "50%"
                    }, {
                        field: "pson_onclock_pattern",
                        title: "艺人上钟模式设置",
                        width: "50%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.tpgmSub(row.id, check_stock, 'pson_onclock_pattern');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>台费</option><option value='2'>台票</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>台费</option><option value='2' selected>台票</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getSzmsList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Setting/getShopConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            smzmSub: function(id, check_stock, key) {
                const _this = this;

                Vue.axios.post('Setting/setShopConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                           [key]: check_stock
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.smzmList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    // 艺人签到后多久可签退
    .store-yqd-set {
        .input-val {
            height: 30px;
            padding: 0 8px;
            margin: 0 10px 0 0;
            border: 1px solid #d6d6d6;
        }
    }
</style>